import React from "react";
import { Link, useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  const handleCategorySearch = (category) => {
    navigate(`/search?q=${category}`);
  };

  return (
    <footer>
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Devanshi Corporation</h3>
            <p>
              Your trusted partner in import of industrial chemicals since 2000.
              Quality products, competitive prices, and reliable service.
            </p>
          </div>
          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/products">Products</Link>
              </li>
              <li>
                <Link to="/about">About Us</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
            </ul>
          </div>
          <div className="footer-section">
            <h3>Product Categories</h3>
            <ul>
              <li onClick={() => handleCategorySearch("industrial")}>
                Industrial Chemicals
              </li>
              <li onClick={() => handleCategorySearch("compound")}>
                Chemical Compounds
              </li>
              <li onClick={() => handleCategorySearch("potassium")}>
                Potassium Products
              </li>
              <li onClick={() => handleCategorySearch("salts")}>
                Specialty Salts
              </li>
            </ul>
          </div>
          <div className="footer-section">
            <h3>Contact Info</h3>
            <ul>
              <li>📍 Mumbai, Maharashtra</li>
              <li>📞 +91-9920850545</li>
              <li>📧 devanshicorporation@gmail.com</li>
              <li>🌐 GST: 27AAEHP0870M1ZU</li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>
            &copy; 2024 Devanshi Corporation. All rights reserved. | GST:
            27AAEHP0870M1ZU
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
